export default function BigIdea() {
    return (
        <section
            className="relative px-6 md:px-10 py-16 md:py-24 bg-[#C2410C] text-white overflow-hidden border-y-4 border-black"
            data-testid="big-idea-section"
        >
            <div className="absolute -top-20 -right-20 w-[300px] h-[300px] rounded-full bg-[#D4A017] opacity-30 blur-3xl" aria-hidden />
            <div className="relative max-w-7xl mx-auto reveal">
                <h2 className="font-display tracking-tighter font-black leading-[0.95] text-5xl sm:text-6xl md:text-7xl lg:text-[6.5rem] text-white">
                    Everyone has a song
                    <br />
                    inside <em className="not-italic bg-[#D4A017] text-black px-3 -rotate-1 inline-block">them.</em>
                </h2>

                <div className="mt-12 grid md:grid-cols-2 gap-10 md:gap-16">
                    <div>
                        <p className="text-white/90 text-base md:text-lg leading-relaxed">
                            Most people never release music because they think
                            they&rsquo;re not talented enough. That studios are too
                            expensive. That they don&rsquo;t know any producers.
                            That the music industry feels impossible to
                            access.
                        </p>
                        <p className="mt-5 text-white text-base md:text-lg leading-relaxed">
                            <span className="font-display font-bold bg-black px-2 py-0.5">My First Single</span> changes that.
                        </p>
                    </div>

                    <div>
                        <div className="eyebrow text-white/80 mb-4">We combine</div>
                        <ul className="space-y-3 text-white">
                            {[
                                "Vocal coaching",
                                "Songwriting support",
                                "Advanced music production technology",
                                "Professional producers",
                                "Studio recording sessions",
                                "Full music distribution",
                            ].map((item, i) => (
                                <li key={item} className="flex items-baseline gap-3">
                                    <span className="font-mono text-[10px] text-[#D4A017] mt-1 font-bold">
                                        0{i + 1}
                                    </span>
                                    <span className="text-base md:text-lg">{item}</span>
                                </li>
                            ))}
                        </ul>
                        <p className="mt-7 font-display text-2xl md:text-3xl leading-tight">
                            You bring the dream.
                            <br />
                            <span className="text-[#D4A017]">We help you release it.</span>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
